export default __webpack_public_path__ + "static/media/05_photo.c41a37f0.jpg";